import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://nevskifit.com';

// This is a client-rendered SPA (no SSR/prerendering), so social crawlers
// (Facebook, Twitter, Slack, ...) never execute JS and only ever see the
// static Open Graph tags in public/index.html, regardless of route. Only
// title/description/canonical are managed here since those are what
// Googlebot's JS-rendered pass and search snippets actually use per page.
function SEO({ title, description, path = '/', jsonLd }) {
  const fullTitle = `${title} | NevskiFit`;
  const url = `${SITE_URL}${path}`;
  const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {jsonLdList.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export default SEO;
